import { useEffect, useRef } from 'react'
import { useAudioStore } from '@/store/AudioStore.ts'

export const useGlobalAudio = () => {
    const { isPlaying } = useAudioStore()
    const audioRef = useRef<HTMLAudioElement | null>(null)

    useEffect(() => {
        if (isPlaying) {
            audioRef.current?.play().catch((error) => {
                console.error('Audio play failed:', error)
            })
        } else {
            audioRef.current?.pause()
        }
    }, [isPlaying])

    return {
        audioRef,
        audioSrc: '/emergency-alert.mp3'
    }
}
